import { ReactNode } from 'react';

import { useDocumentVisibleOnce } from '@domains/pdp-common';

import { RelatedRecommendCarousels } from '../components/carousel/RelatedRecommendCarousels';
import { useBottomRelatedRecommendListService } from '../services/useBottomRelatedRecommendListService';

interface RelatedRecommendListContainerProps {
  productId: string;
  children?: ReactNode;
  isInfiniteRecommend?: boolean;
}

export const BottomRelatedRecommendListContainer = ({
  productId,
  children,
  isInfiniteRecommend,
}: RelatedRecommendListContainerProps) => {
  const { ref, isPermanentlyOnce } = useDocumentVisibleOnce();
  const { isHide, bottomRelatedRecommendList, onImpressionProduct, onClickProduct, onSavedProduct, onClickMore } =
    useBottomRelatedRecommendListService(productId, isInfiniteRecommend);

  if (isHide) {
    return null;
  }

  return (
    <div ref={ref}>
      {isPermanentlyOnce && !isInfiniteRecommend && (
        <>
          {children}
          <RelatedRecommendCarousels
            lists={bottomRelatedRecommendList}
            onImpressionProduct={onImpressionProduct}
            onClickProduct={onClickProduct}
            onSaveProduct={onSavedProduct}
            onClickMore={onClickMore}
          />
        </>
      )}
    </div>
  );
};
